<template>
    <section class="p-0" id="coverage">
        <div id="coverage-header" class="masthead text-white text-center">
            <div class="container h-100 d-flex justify-content-center">
                <div class="my-auto">
                    <hr class="light" data-aos="fade-right">
                    <h1 class="text-white">
                    COBERTURA <br>
                    experiencia internacional
                    </h1>
                    <hr class="light" data-aos="fade-left">
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row text-center">
                <div class="col-xl-12 d-none d-lg-block">
                    <div class="col-xl-12 map-container">
                        <img class="img-fluid" src="/../img/Mapa_Internacional.png">
                        <h2 class="desktop-title-international">Cobertura<br> Internacional</h2>
                        <img class="desktop-img" src="/../img/maps/paises.png">
                        <hover-boxes :boxes="boxes" @close-box="closeBox" />
                        <div v-for="box in boxes" :key="box.id">
                            <div class="opener" @mouseover="mouseOver(box)" :class="box.class" :id="box.id"></div>
                        </div>
                    </div>
                </div>
                <div class="d-lg-none">
                    <div data-aos="fade-right" class="col-lg-9 col-md-12">
                        <img class="img-fluid" src="/../img/mapa.png">
                    </div>
                    <div data-aos="fade-left" class="col-lg-3 col-md-12">
                        <ul class="text-center">
                            <li class="parent"><p class="lead text-center">Estados Unidos</p></li>
                            <li class="parent"><p class="lead text-center">Panamá</p></li>
                            <li class="parent"><p class="lead text-center">Nicaragua</p></li>
                            <li class="parent"><p class="lead text-center">Perú</p></li>
                            <li class="parent"><p class="lead text-center">México</p></li>
                            <li class="parent"><p class="lead text-center">Rep. Dominicana</p></li>
                            <li class="parent"><p class="lead text-center">Guatemala</p></li>
                            <li class="parent"><p class="lead text-center">Honduras</p></li>
                            <li class="parent"><p class="lead text-center">Puerto Rico</p></li>
                            <li class="parent"><p class="lead text-center">El Salvador</p></li>
                            <li class="parent"><p class="lead text-center">Costa Rica</p></li>
                            <li class="parent"><p class="lead text-center">Colombia</p></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid p-0">
            <div class="row reddet text-center text-white p-2">
                <div class="col-lg-4 col-md-12">
                    <p style="margin-bottom: 0!important">
                        Especialistas en punto de compra <a target="_blank" href="https://www.visionymarketing.com.co"><br><img height="60" src="/../img/Logos_VyM.png"></a>
                    </p>
                </div>
                <div class="col-lg-4 col-md-12">
                    <p style="margin-bottom: 0!important">
                        Especialistas de shopper marketing a nivel LATAM
                        <a target="_blank" href=" http://redvolutionlatam.com"><br><img height="60" src="/../img/Logos_Redvolution.png"></a>
                    </p>
                </div>
                <div class="col-lg-4 col-md-12">
                    <p style="margin-bottom: 0!important">
                        Especialistas en crear experiencias memorables de consumo
                        <a target="_blank" href=" http://www.touch.cl"><br><img height="60" src="/../img/touch-blanco-01.png"></a>
                    </p>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row text-center">
                <div class="col-xl-12 map-container">
                    <img class="img-fluid" src="/../img/maps/Mapa_Mexico.png">
                    <h2 class="desktop-title-national">Cobertura<br> Nacional</h2>
                    <img class="d-none d-lg-block desktop-img-offices" src="/../img/maps/oficinas.png">
                    <img class="d-none d-lg-block desktop-img-rooms" src="/../img/maps/salas.png">
                </div>
            </div>
        </div>
        <div class="col-md-12 text-center text-white p-2 reddet">
            <h3 class="text-white m-0">EMPRESAS DEL GRUPO</h3>
        </div>
        <div class="container-fluid p-0">
            <div class="row no-gutters">
                <div class="col-lg col-md-12 text-center text-white p-1">
                    <div class="container p-0 plecas">
                        <div class="row">
                            <div class="col-md-6 d-inline d-flex align-items-center">
                                <p class="text-dark lead text-center">Experiencias BTL</p>
                            </div>
                            <div class="col-md-6">
                                <a target="_blank" href="http://www.fanatic.lat">
                                    <img class="responsive mx-auto" src="/../img/fanatic.png">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg col-md-12 text-center text-white p-1">
                    <div class="container p-0 plecas">
                        <div class="row">
                            <div class="col-md-6 d-inline d-flex align-items-center">
                                <p class="text-dark lead text-center">Mobiliario y material PDV</p>
                            </div>
                            <div class="col-md-6">
                                <a target="_blank" href="/area3d/pdf">
                                    <img class="responsive mx-auto" src="/../img/area3d.png">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg col-md-12 text-center text-white p-1">
                    <div class="container p-0 plecas">
                        <div class="row">
                            <div class="col-md-6 d-inline d-flex align-items-center">
                                <p class="text-dark lead text-center">Logística especializada en POP</p>
                            </div>
                            <div class="col-md-6">
                                <a target="_blank" href="http://www.361.com.mx/">
                                    <img class="responsive mx-auto" src="/../img/361.png">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg col-md-12 text-center text-white p-1">
                    <div class="container p-0 plecas">
                        <div class="row">
                            <div class="col-md-6 d-inline d-flex align-items-center">
                                <p class="text-dark lead text-center">Rappi</p>
                            </div>
                            <div class="col-md-6">
                                <a target="_blank" href="https://www.rappi.com">
                                    <img class="responsive mx-auto" src="/../img/rappi.png">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import HoverBoxes from './HoverBoxes.vue'
    import boxes from "./BoxesData.js";
    export default {
        name: 'Coverage',
        components: {
            HoverBoxes
        },
        data () {
            return {
                boxes: boxes.boxes,
            }
        },
        methods: {
            mouseOver (b) {
                this.boxes.forEach((item, index) => {
                    item.active = false
                })

                b.active = true
            },
            closeBox (box) {
                let item
                item = this.boxes.find((item) => {
                    return item.id == box.id
                })

                item.active = false
            }
        }
    }
</script>
<style scoped lang="scss">
    @import "./Coverage.scss"
</style>


// WEBPACK FOOTER //
// resources/assets/vue/components/coverage/Coverage.vue